import styled from 'styled-components';
import React from 'react';
import { motion } from 'framer-motion';
import { fadeTop } from '../../utils/animations';

const Titrevaleur = () => {
    return (
        <motion.div initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeTop}>
            <Postitle>
                    <Texttitle>NOS VALEURS</Texttitle>
            </Postitle>
        </motion.div>
    );
};

const Texttitle = styled.h1`
    text-decoration: none;
    color: black;
    font-size: 70px;
    font-family: 'Greycliff CF';
`;

const Postitle = styled.div`
    position: relative;
    margin-left: 13%;
    margin-top: 5%;

    @media screen and (max-width: 1300px) {
        width: 100%;
        text-align: center;
        margin-left: 0;
    }
`;

export default Titrevaleur;
